import { Grid, Paper } from "@material-ui/core";
import { SelectIcon } from "App/Assets";
import {
	InputCheckboxMaster,
	InputTextMaster,
	LabelRequired,
	MasterButton,
} from "App/Component/ui";
import OrganisasiLokasiPreview from "../OrganisasiLokasiPreview";

export default function OrganisasiInfo({
	formDataInfo,
	setFormDataInfo,
	showModalLokasi,
	setShowModalLokasi,
	lokasi,
	setLokasi,
}) {
	const handleOpenLokasi = async () => {
		setShowModalLokasi(!showModalLokasi);
	};

	const handleChange = (text) => (e) => {
		setFormDataInfo({
			...formDataInfo,
			[text]: e.target.value,
		});
	};

	return (
		<>
			{showModalLokasi && (
				<OrganisasiLokasiPreview
					setShowModal={() => setShowModalLokasi(false)}
					lokasi={lokasi}
					setLokasi={setLokasi}
				/>
			)}
			<Paper className="p-1 mb-2">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<h4>INFO ORGANISASI</h4>
					<InputCheckboxMaster
						checked={formDataInfo.active}
						name="active"
						id="active"
						label="Aktif"
						onChange={() =>
							setFormDataInfo({
								...formDataInfo,
								active: !formDataInfo.active,
							})
						}
					/>
				</div>
				<form onSubmit={(e) => console.log("No Method")}>
					<Grid container spacing={1}>
						<Grid item md={3}>
							<InputTextMaster
								name="kode"
								label={<LabelRequired label="Kode Organisasi" />}
								id="kode"
								placeholder="Kode Ruangan"
								value={formDataInfo.kode}
								onChange={handleChange("kode")}
							/>
						</Grid>
						<Grid item md={3}>
							<InputTextMaster
								name="name"
								label={<LabelRequired label="Nama Organisasi" />}
								id="name"
								placeholder="Nama Organisasi"
								value={formDataInfo.name}
								onChange={handleChange("name")}
							/>
						</Grid>
						<Grid item md={3}>
							<InputTextMaster
								name="alias"
								label="Alias Organisasi"
								id="alias"
								placeholder="Alias Organisasi"
								value={formDataInfo.alias}
								onChange={handleChange("alias")}
							/>
						</Grid>
						<Grid item md={3}>
							<div
								style={{
									display: "flex",
								}}
							>
								<InputTextMaster
									name="location"
									label={<LabelRequired label="Lokasi Organisasi" />}
									id="location"
									readOnly
									placeholder="Lokasi Organisasi"
									value={lokasi.nama}
									onChange={handleChange("location")}
								/>
								<MasterButton
									type={"button"}
									color="lightgreen"
									name=""
									size="sm"
									withIcon={true}
									onClick={() => handleOpenLokasi()}
									style={{
										marginTop: "1.5rem",
										width: "32px",
										height: "32px",
									}}
									icon={
										<SelectIcon
											width="16px"
											height="16px"
											style={{
												marginLeft: "-0.5rem",
											}}
										/>
									}
								/>
							</div>
						</Grid>
					</Grid>
				</form>
			</Paper>
		</>
	);
}
